import {
  createColumn,
  formatDateTime,
  numberFormat,
} from "../../utils/helpers";
import { TFieldConfig } from "../../types/common";
import { API_BOOKINGS } from "../../utils/apis";
import { CONFIRMED, STICKER } from "../../utils/constants";
import { PaymentStatusTag } from "../../components/common/registerUtils";

interface UseVehicleLedgerStickersProps {
  form: any;
  updateFormValue: (field: string, value: any) => void;
  updateFormValues: (values: any) => void;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  filters: any;
  setFilters: (filters: any) => void;
  setError: (error: any) => void;
}

export const useVehicleLedgerStickers = ({}: UseVehicleLedgerStickersProps) => {
  const searchFields: TFieldConfig[] = [
    {
      field_name: "car_number",
      label: "Car Number",
      type: "text",
      props: {
        placeholder: "Enter car number",
        required: true,
      },
    },
  ];

  const tableColumns = () => [
    createColumn("booking_number", false, "Booking Number"),
    createColumn("invoice_amount", false, "Invoice Amount"),
    createColumn("phone_number", false, "Phone Number"),
    createColumn("email", false, "Email"),
    createColumn("start_date", false, "Start Date"),
    createColumn("end_date", false, "End Date"),
    createColumn("city_name", false, "City Name"),
    createColumn("payment_status", false, "Payment Status"),
    createColumn("car_type", false, "Car Type"),
  ];

  const tableData = (data: any) => {
    if (!data) return [];

    return data?.map((item: any) => ({
      ...item,
      booking_number: item.booking_number || "N/A",
      invoice_amount: numberFormat(item.invoice_amount || 0),
      phone_number: item.phone_number || "N/A",
      email: item.email || "N/A",
      start_date: formatDateTime(item.start_date) || "N/A",
      end_date: formatDateTime(item.end_date) || "N/A",
      city_name: item.city_name || "N/A",
      payment_status: <PaymentStatusTag status={item.payment_status} />,
      car_type: item.car_type || "N/A",
    }));
  };

  const api = API_BOOKINGS;
  const tableTitle = "Stickers";
  const initialFilters = { booking_type: STICKER, status: CONFIRMED };
  // const exportData = {
  //   api: `${API_BOOKINGS}/export/`,
  //   fileName: "vehicle_stickers.xlsx",
  // };

  return {
    searchFields,
    tableColumns,
    tableData,
    tableTitle,
    api,
    initialFilters,
    // exportData,
  };
};
